enum IncomeTrustClassTypeEnum {
    ClassC = 'CLASS_C',
    ClassD = 'CLASS_D',
}

export default IncomeTrustClassTypeEnum;
